import type * as React from 'react';
import { t } from '@reos/i18n';
import { PreparingSection, PREPARING_SOON_BADGE } from '../components/PreparingSection.js';
import { pilotVisibilityForPath } from '../lib/nav.js';
import { PREPARING_SECTIONS } from '../lib/texts.js';

/**
 * Stranka nehotove sekce (zadani BLOK 2, ukol 2): polozky menu bez obsahu
 * nikdy nevedou na 404 ani na prazdno — vzdy stav PRIPRAVUJE SE s popisem,
 * co v sekci bude. Texty drzi src/lib/texts.ts.
 */
export function PreparingPage({ path }: { readonly path: string }): React.JSX.Element {
  const copy = PREPARING_SECTIONS[path] ?? {
    title: path,
    perex: t('webAdmin.preparing.fallbackPerex', { locale: 'cs' }),
    bullets: [],
  };
  // Krok UX1 (AUD1 §3.2): skupina „brzy/beta“ nese jednotný štítek „Obchod brzy“,
  // zbytek nechává „PŘIPRAVUJE SE“. Rozhodnutí je v `nav.ts` u položky.
  return <PreparingSection copy={copy} {...(pilotVisibilityForPath(path) === 'soon' ? { badge: PREPARING_SOON_BADGE } : {})} />;
}
